<template>
  <div class="tabulka" :class="TableWidth">
    <div class="tabulka__top">
      <div class="tabulka__top__nadpis">
        Financial overview:
        <span class="tabulka__top__nadpis__violet">{{ teamName }}</span>
      </div>
      <BalanceList
        :teamId="teamId"
        :teamName="teamName"
        :teamMoney="teamMoney"
      />
    </div>
    <div class="tabulka__body">
      <table>
        <thead>
          <td>
            <span>Round</span>
            <SortButton
              row="turn"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
            />
          </td>
          <td class="right">
            <SortButton
              row="turnStartMoney"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Initial</span>
          </td>
          <td class="right">
            <SortButton
              row="spent"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Spent</span>
          </td>
          <td class="right">
            <SortButton
              row="turnEndMoney"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Result</span>
          </td>
          <td class="right">
            <SortButton
              row="earned"
              type="0"
              :currentSortDirection="currentSortDirection"
              :currentSortRow="currentSortRow"
              v-on:sortBy="sortRow"
              floatRight="yes"
            />
            <span>Earned</span>
          </td>
        </thead>
        <tr
          v-for="(round, index) in sortedData"
          :key="round.id"
          v-show="round.turn > 0"
        >
          <td class="important">
            <span>{{ round.turn }}.</span>
          </td>
          <td class="right">
            {{ round.turnStartMoney | numbersThousands | inCurrency }}
          </td>
          <td class="right" :class="{ red: round.spent > 0 }">
            <span v-if="round.spent > 0">- </span>
            {{ round.spent | numbersThousands | inCurrency }}
          </td>
          <td
            class="right"
            :class="{ importantResult: index == sortedData.length - 1 }"
          >
            {{ round.turnEndMoney | numbersThousands | inCurrency }}
          </td>
          <td class="right" :class="{ green: round.earned > 0 }">
            {{ round.earned | numbersThousands | inCurrency }}
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>


<script>
import SortButton from "@/components/game/table/SortButton.vue";
import sortingLogicMixin from "@/components/game/table/sortingLogicMixin.js"; // obsahuje logiku k sortovani

import BalanceList from "@/components/game/table/BalanceList.vue";

export default {
  name: "FinancialOverviewTeams",
  mixins: [sortingLogicMixin],
  props: {
    TableWidth: String,
    sourceData: Array,
    teamName: String,
    teamMoney: Number,
    teamId: Number,
  },
  components: {
    SortButton,
    BalanceList,
  },
  data() {
    return {
      currentSortRow: "turn",
      currentSortDirection: 1,
      startingMoney: 5000,
    };
  },
  methods: {
    getStartedMoney(money, earned) {
      var start_money = this.startingMoney;
      this.startingMoney = money + earned;
      return start_money;
    },
  },
};
</script>
